import React from 'react'
import { useShoukuanlxDelMutation } from '../../../store/DianShangYeWuApi'
import Icon from '../../../cpn/Icon';
import { App } from 'antd'
function IncomeTypeDel(props) {
    const {message} = App.useApp()
    const [submitDel] = useShoukuanlxDelMutation()
    return (
        <Icon type='delete' 
            onClick={() => {
                submitDel({
                    sklx_id:props.sklx_id,
                }).then((res) => {
                    if (res.data.Status === 'success') {
                        message.info('删除成功');
                    }
                    if (res.data.Status === "fail") {
                        message.error('删除失败：'+res.data.Message)
                    }
                })
            }}
        > </Icon>
    )
    }

export default IncomeTypeDel